const SITUATION_PROPOSALS = {
  CREATED: 'Criada',
  REJECTED: 'Rejeitada',
  PAID: 'Paga',
  CREDIT_ANALYSIS: 'Crédito em análise',
  PENDING_ACTION: 'Pendente',
  PRE_QUALIFICATION: 'Pré qualificação',
}

const SITUATION_PROPOSALS_HOME_FIN_FILTER = {
  IN_PROGRESS: 'Em andamento',
  CONCLUDED: 'Concluído',
  CLOSED: 'Descartado',
}

const SITUATION_PROPOSALS_FILTER = {
  REJECTED: SITUATION_PROPOSALS.REJECTED,
  PENDING_ACTION: SITUATION_PROPOSALS.PENDING_ACTION,
  PAID: SITUATION_PROPOSALS.PAID,
}

export {
  SITUATION_PROPOSALS,
  SITUATION_PROPOSALS_FILTER,
  SITUATION_PROPOSALS_HOME_FIN_FILTER,
}
